import React from 'react';
import './home.css';


function Home(){
    return(
        <div className="home"><div className='text-center'>
            <h1>Project Content</h1>
            <h2>Main page -- Catalog</h2>
            <h4>.- Login with firebase</h4>
            <h4>  .-Authenticated user</h4>
            <h4>   .-Form to update the Catalog</h4>
            <h4>   .-Add product to cart</h4>
            <h4>   .-API Request</h4>
            <h4>    .- railway</h4>
            <h4>   .- React</h4>
            <h4>   .- Chart.js</h4>
            <h4>    .-Sequelize</h4>
            <h4>  .-Mysql</h4>
            <h4> .-Html</h4>
            <h4> .-CSS</h4>
            <h4>  .-JavaScript</h4>
            <h4>  .-GitHub</h4>
            <h4>  .-Bootstrap</h4>
            <h4>  .-Primereact</h4>
            
        </div></div>
    )
}

export default Home